import store from '../../store/store';
import enabledSetting from './field-validation/enabledSetting';
import FieldDefinitionAE from './field-validation/fieldDefinitionByCountry/ArabEmirates/FieldDefinitionAE';
import FieldDefinitionAT from './field-validation/fieldDefinitionByCountry/Austria/FieldDefinitionAT';
import FieldDefinitionAU from './field-validation/fieldDefinitionByCountry/Australia/FieldDefinitionAU';
import FieldDefinitionBH from './field-validation/fieldDefinitionByCountry/Bahrain/FieldDefinitionBH';
import FieldDefinitionBR from './field-validation/fieldDefinitionByCountry/Brasil/FieldDefinitionBR';
import FieldDefinitionBG from './field-validation/fieldDefinitionByCountry/Bulgaria/FieldDefinitionBG';
import FieldDefinitionCA from './field-validation/fieldDefinitionByCountry/Canada/FieldDefinitionCA';
import FieldDefinitionIL from './field-validation/fieldDefinitionByCountry/Israel/FieldDefinitionIL';
import FieldDefinitionCH from './field-validation/fieldDefinitionByCountry/Switzerland/FieldDefinitionCH';
import FieldDefinitionCN from './field-validation/fieldDefinitionByCountry/China/FieldDefinitionCN';
import FieldDefinitionCNWithLoqate from './field-validation/fieldDefinitionByCountry/China/FieldDefinitionCNWithLoqate';
import FieldDefinitionCNWithValidation
from './field-validation/fieldDefinitionByCountry/China/FieldDefinitionCNWithValidation';
import FieldDefinitionDefault from './field-validation/fieldDefinitionByCountry/DefaultCountry/FieldDefinitionDefault';
import FieldDefinitionDK from './field-validation/fieldDefinitionByCountry/Denmark/FieldDefinitionDK';
import FieldDefinitionFR from './field-validation/fieldDefinitionByCountry/France/FieldDefinitionFR';
import FieldDefinitionDE from './field-validation/fieldDefinitionByCountry/Germany/FieldDefinitionDE';
import FieldDefinitionGR from './field-validation/fieldDefinitionByCountry/Greece/FieldDefinitionGR';
import FieldDefinitionHK from './field-validation/fieldDefinitionByCountry/HongKong/FieldDefinitionHK';
import FieldDefinitionIN from './field-validation/fieldDefinitionByCountry/India/FieldDefinitionIN';
import FieldDefinitionIE from './field-validation/fieldDefinitionByCountry/Ireland/FieldDefinitionIE';
import FieldDefinitionIT from './field-validation/fieldDefinitionByCountry/Italy/FieldDefinitionIT';
import FieldDefinitionJP from './field-validation/fieldDefinitionByCountry/Japan/FieldDefinitionJP';
import FieldDefinitionKRWithValidation
from './field-validation/fieldDefinitionByCountry/Korea/FieldDefinitionKRWithValidation';
import FieldDefinitionLV from './field-validation/fieldDefinitionByCountry/Latvia/FieldDefinitionLV';
import FieldDefinitionLT from './field-validation/fieldDefinitionByCountry/Lithuania/FieldDefinitionLT';
import FieldDefinitionLU from './field-validation/fieldDefinitionByCountry/Luxembourg/FieldDefinitionLU';
import FieldDefinitionMY from './field-validation/fieldDefinitionByCountry/Malaysia/FieldDefinitionMY';
import FieldDefinitionNL from './field-validation/fieldDefinitionByCountry/Netherlands/FieldDefinitionNL';
import FieldDefinitionNZ from './field-validation/fieldDefinitionByCountry/NewZealand/FieldDefinitionNZ';
import FieldDefinitionPL from './field-validation/fieldDefinitionByCountry/Poland/FieldDefinitionPL';
import FieldDefinitionPT from './field-validation/fieldDefinitionByCountry/Portugal/FieldDefinitionPT';
import FieldDefinitionRO from './field-validation/fieldDefinitionByCountry/Romania/FieldDefinitionRO';
import FieldDefinitionRU from './field-validation/fieldDefinitionByCountry/Russia/FieldDefinitionRU';
import FieldDefinitionSA from './field-validation/fieldDefinitionByCountry/SaudiArabia/FieldDefinitionSA';
import FieldDefinitionSE from './field-validation/fieldDefinitionByCountry/Sweden/FieldDefinitionSE';
import FieldDefinitionSI from './field-validation/fieldDefinitionByCountry/Slovenia/FieldDefinitionSI';
import FieldDefinitionES from './field-validation/fieldDefinitionByCountry/Spain/FieldDefinitionES';
import FieldDefinitionTW from './field-validation/fieldDefinitionByCountry/Taiwan/FieldDefinitionTW';
import FieldDefinitionTH from './field-validation/fieldDefinitionByCountry/Thailand/FieldDefinitionTH';
import FieldDefinitionGB from './field-validation/fieldDefinitionByCountry/UK/FieldDefinitionGB';
import FieldDefinitionUS from './field-validation/fieldDefinitionByCountry/US/FieldDefinitionUS';

const getChinaDefinition = () => {
  if (enabledSetting('should_use_new_chinese_field_validation')) {
    return FieldDefinitionCNWithValidation;
  }
  
  if (enabledSetting('address_lookup_countries')?.includes('CN')) {
    return FieldDefinitionCNWithLoqate;
  }
  
  return FieldDefinitionCN;
};

const getCountryDefinition = (country) => {
  const countryDefinitions = {
    AE: FieldDefinitionAE,
    AT: FieldDefinitionAT,
    AU: FieldDefinitionAU,
    BH: FieldDefinitionBH,
    BG: enabledSetting('should_use_new_bulgarian_field_validation') ? FieldDefinitionBG : FieldDefinitionDefault,
    BR: FieldDefinitionBR,
    CA: FieldDefinitionCA,
    CH: FieldDefinitionCH,
    CN: getChinaDefinition(),
    DE: FieldDefinitionDE,
    DK: FieldDefinitionDK,
    ES: FieldDefinitionES,
    FR: FieldDefinitionFR,
    GB: FieldDefinitionGB,
    GR: FieldDefinitionGR,
    HK: FieldDefinitionHK,
    IE: FieldDefinitionIE,
    IL: FieldDefinitionIL,
    IN: FieldDefinitionIN,
    IT: FieldDefinitionIT,
    JP: FieldDefinitionJP,
    KR: FieldDefinitionKRWithValidation,
    LT: FieldDefinitionLT,
    LU: FieldDefinitionLU,
    LV: FieldDefinitionLV,
    MY: FieldDefinitionMY,
    NL: FieldDefinitionNL,
    NZ: FieldDefinitionNZ,
    PL: FieldDefinitionPL,
    PT: FieldDefinitionPT,
    RO: FieldDefinitionRO,
    RU: FieldDefinitionRU,
    SA: FieldDefinitionSA,
    SI: FieldDefinitionSI,
    SE: FieldDefinitionSE,
    TH: FieldDefinitionTH,
    TW: FieldDefinitionTW,
    US: FieldDefinitionUS,
  };
  
  return countryDefinitions[country] || FieldDefinitionDefault;
};

const addressDefinitionsByCountry = {
  get: getCountryDefinition,
};

export default addressDefinitionsByCountry;
